/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

import { EnvConfig } from '@clean-code/models/common';
import { AzureConfig } from '@clean-code/shared/auth/util-azure';
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
declare let require: any;

const TENANT_GUID = '08f06a7d-6a4c-495c-a276-26cc8ac21409';
const CLIENT_ID = '17ab109c-3895-4c88-a31a-12dfdfbc2636';
const server_url = 'https://limit-reports-hc.frontoffice.clean-code.pro';

export const protectedResources = {
  api: {
    endpoint: server_url + '/api',
    scopes: ['api://' + CLIENT_ID + '/user_impersonation'],
  },
  graphql: {
    endpoint: server_url + '/graphql',
    scopes: ['api://' + CLIENT_ID + '/user_impersonation'],
  },
};

const protectedResourceMap = new Map<string, Array<string>>();
// Do not map the bare origin — that also matches static assets like /assets/i18n/*.json
protectedResourceMap.set(
  protectedResources.api.endpoint,
  protectedResources.api.scopes,
);
protectedResourceMap.set(
  protectedResources.graphql.endpoint,
  protectedResources.graphql.scopes,
);

const authOption: AzureConfig = {
  auth: {
    clientId: CLIENT_ID, // PPE testing environment
    authority: 'https://login.microsoftonline.com/' + TENANT_GUID, // PPE testing environment.
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  protectedResourceMap: protectedResourceMap,
};

export const environment: EnvConfig = {
  production: false,
  env: 'dev',
  tenant: 'frontoffice-int',
  name: 'FrontOffice-Int - DEV',
  api: server_url + '/api/',
  graphql: server_url + '/graphql',

  version: require('../../package.json').version,
  origins: ['localhost', server_url + '/api', server_url + '/graphql'],
  auth: authOption,
  signalR: {
    api: server_url + '/',
  },
  instrumentationKey: 'e95435bc-7d96-48e9-9aba-96ead1569e28',
  sentryEnv: 'DevTest',
  enableSentry: true,
};
